import {
  Box,
  Flex,
  Image,
  Spacer,
  Spinner,
  Stack,
  Text,
  VStack,
} from '@chakra-ui/react';
import { navigate } from '@reach/router';
import { Auth } from 'aws-amplify';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import bgImage from '../../assets/auth_bg.png';
import ForgotPasswordForm from '../../components/auth/forget-password';
import SignInForm from '../../components/auth/sign-form/signin-form';
import SignUpForm from '../../components/auth/signup-form';
import MerchantOnboarding from '../../components/merchant-onboarding';
import { isLoggedIn } from '../../utils/auth';

const LoginPage = ({ initUser }) => {
  const [viewState, setViewState] = useState('signin');
  const [pageError] = useState(false);
  const [step, setStep] = useState(null);
  const [pageLoading, setPageLoading] = useState(false);

  useEffect(() => {
    async function check() {
      try {
        setPageLoading(true);
        const session = await Auth.currentSession();
        session.getIdToken().getJwtToken();
        if (!isLoggedIn) {
          return;
        }
        await Auth.currentAuthenticatedUser();
        initUser().then(() => {
          navigate('/');
          setPageLoading(false);
        });
      } catch (error) {
        setPageLoading(false);
      }
    }
    check();
  }, []);

  return (
    <Box>
      <Flex
        minH="100vh"
        align="center"
        justify="center"
        backgroundImage={bgImage}
        backgroundSize="100% 100%"
      >
        <Flex align="center" w={{ base: '100%', xl: '80%' }}>
          <Box display={{ base: 'none', xl: 'block' }}>
            <Image src={require('../../assets/logo/small.svg')} />
          </Box>
          <Stack
            spacing={8}
            mx="auto"
            maxW="3xl"
            w={{ base: '100%', xl: '60%' }}
            className="loginBlock"
            boxShadow="xl"
            rounded="lg"
          >
            <Flex>
              <Box p="4" />
              <Spacer />
              <Box
                px="4"
                bg="brand.red"
                color="#fff"
                roundedBottomLeft="lg"
                lineHeight="30px"
                fontSize="18px"
                letterSpacing="0.25em"
                height="31px"
              >
                Merchant Login
              </Box>
            </Flex>

            {pageLoading ? (
              <VStack>
                <Spinner />
                <Text>Loading...</Text>
              </VStack>
            ) : pageError ? (
              <Text>Something went wrong... Please try refreshing</Text>
            ) : (
              <>
                {viewState === 'signin' ? (
                  <SignInForm
                    switchToSignUp={() => setViewState('signup')}
                    switchToOnboarding={(s) => {
                      setViewState('onboarding');
                      if (typeof s === 'number') {
                        setStep(s);
                      }
                    }}
                    switchToForgotPassword={() =>
                      setViewState('forgot-password')
                    }
                  />
                ) : viewState === 'signup' ? (
                  <SignUpForm switchToSignIn={() => setViewState('signin')} />
                ) : viewState === 'forgot-password' ? (
                  <ForgotPasswordForm
                    swichToLogin={() => setViewState('signin')}
                  />
                ) : viewState === 'onboarding' ? (
                  <MerchantOnboarding
                    backToLogin={() => setViewState('signin')}
                    {...{ step }}
                  />
                ) : null}
              </>
            )}

            <Box w="35%" h="1" bg="brand.red" roundedTopRight="md" />
          </Stack>
        </Flex>
      </Flex>
    </Box>
  );
};

const stateMapper = () => ({});
const dispatchMapper = (dispatch) => ({
  initUser: dispatch.auth.fetchAndSetUser,
});

export default connect(stateMapper, dispatchMapper)(LoginPage);
